






import { Component, Vue } from 'vue-property-decorator';
import { State, Action } from 'vuex-class';
import { Loading, Message } from 'element-ui';

@Component({
  name: 'app',
  metaInfo() {
    return {
      title: this.$store.state.AppMod.pageTitle
    };
  }
})
export default class App extends Vue {}
